import { render, staticRenderFns } from "./signNeighborhoodPact.vue?vue&type=template&id=0b4c24ee&scoped=true&"
import script from "./signNeighborhoodPact.vue?vue&type=script&lang=js&"
export * from "./signNeighborhoodPact.vue?vue&type=script&lang=js&"
import style0 from "./signNeighborhoodPact.vue?vue&type=style&index=0&id=0b4c24ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c24ee",
  null
  
)

export default component.exports